import { CcLibrarySetModule } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"

export const setCcLibrarySetModuleData = (data: CcLibrarySetModule) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_MODULE_DATA),
    data,
})
export const setCcLibrarySetModuleShowConfirm = (show: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_SET_MODULE_SHOW_CONFIRM),
    show,
})
